export enum Sector {
  EDUCATION = 'education',
  CORPORATE = 'corporate',
}
